export const money = val => (val === null ? '' : `$${val.toString().replace(/(\d\d)$/, '.$1')}`);

export const percentage = val => `${val}%`;
